export function findBestMatch(referenceList, objects, listKey) {
  const refSet = new Set(referenceList);

  let bestObject = null;
  let maxMatches = 0;

  for (const obj of objects) {
    const matches = obj[listKey].split(",").map(item => Number(item.trim())).filter(item => refSet.has(item)).length;

    if (matches > maxMatches) {
      maxMatches = matches;
      bestObject = obj;
    }
  }

  return bestObject;
}